import { render, staticRenderFns } from "./DomicilioAnterior.vue?vue&type=template&id=16b9b252&"
import script from "./DomicilioAnterior.vue?vue&type=script&lang=js&"
export * from "./DomicilioAnterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports